import styled from 'styled-components';

export const Refresh = styled.div`
  position: fixed;
  z-index: 1;
  bottom: 30px;
  right: 60px;
  font-size: 30px;
  text-align: center;
  cursor: pointer;
  padding: 1rem;

  .icon * {
    animation: up-down 1s ease-in-out infinite alternate;
    color: #00b1f1;
  }

  div {
    font-size: 18px;
    font-weight: 600;
    color: #00b1f1;
  }
  :hover {
    div {
      transform: scale(1.1);

      transition: all 0.1s ease-in-out;
    }
  }

  @keyframes up-down {
    0% {
      transform: translateY(3px);
    }
    100% {
      transform: translateY(0px);
    }
  }
`;

export const ContainerGeral = styled.div`
  width: 100%;
  .filter {
    border-radius: 4px;
    margin-bottom: 20px;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 1;
  }

  .semaphoreComponent {
    margin-bottom: 10px;
    border-radius: 4px;
  }

  .kpiComponent {
    border-radius: 4px;
  }

  .graph {
    border-radius: 4px;
    padding: 10px;
  }
`;

export const ContTwoGraph = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 3fr;
  grid-gap: 20px;
  margin-bottom: 20px;
`;

export const Title = styled.h1`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
`;

export const Container = styled.section`
  border-radius: 4px;
  padding: 15px;

  @keyframes keyframeDisplay {
    from {
      display: none;
      opacity: 0;
    }
    25% {
      display: block;
      opacity: 0.25;
    }
    50% {
      display: block;
      opacity: 0.5;
    }
    75% {
      display: block;
      opacity: 0.75;
    }
    to {
      display: block;
      opacity: 1;
    }
  }
`;
